import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute
  ) {

  }

  ngOnInit(): void {
    //this.url = this.activeRoute.snapshot.url;
  }

  appendTypeId(endpoint: string, type: string = "edit") {
    let id = this.getUrlId(type);
    if (id) {
      const regex = /\{id\}/i;
      return endpoint.replace(regex, "/" + id ?? '');
    }
    return endpoint;
  }

  appendId(endpoint: string, id: string | false) {
    if (id) {
      const regex = /\{id\}/i;
      return endpoint.replace(regex, "/" + id ?? '');
    }
    return endpoint;
  }

  getUrlId(page: string = "edit"): string | false {
    /* if (page == 'servizi') {
      return this.getUrlSubId() ?? false;
    } */
    // const pageJson = this.getType(urlJson);
    let url = this.activeRoute.snapshot.url; // UrlSegment[],
    let valSegment = url[url.length - 1];
    let editSegment = url[url.length - 2];
    if (editSegment?.path === page && valSegment?.path.length > 0) return valSegment?.path
    return false;
  }

  /**
   * restituisce l'ultimo segment dell'url json passato come argomento
   * @param urlJson // program_form/edit
   */
  getType(urlJson: string) {
    let segment = urlJson.split('/');
    return segment[segment.length - 1];
  }

  goToPage(page: string, params: {} | null = null, serverCall: boolean = true) {

    const url = '/' + page;


    if (!params) {
      this.router.navigateByUrl(url); // Navigazione senza parametri
      return;
    }

    if (serverCall)
      this.router.navigateByUrl(this.router.createUrlTree([url], { queryParams: params })); // Chiamerò il server per la restituzione dei dati
    else
      this.router.navigate([url], { state: { data: params } }); // Recupererò i parametri dallo state

  }


  currentPage() {
    return this.router.url;
  }

  // ex. localhost:63956/obo-srv/servizi/1?subId=1
  getUrlSubId() {
    return this.activeRoute.snapshot.queryParamMap.get('subId');
    /*return this.activeRoute.queryParams.subscribe(params => {
      return params['subId'];
    });*/
  }

   getQueryParams() {
    return this.activeRoute.queryParams;
  }

}
